import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faClock,
  faBriefcase,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import "./JobCard.css";

function JobCard({ job }) {
  const { user } = useAuth();

  const handleApply = () => {
    if (!user.isAuthenticated) {
      alert("Please log in to apply for this job.");
      return;
    }
  
    alert(`Successfully applied for ${job.title}!`);
  };

  return (
    <div className="job-card">
      <div className="job-card-header">
        <h3 className="job-title">{job.title}</h3>
        <span className="job-company">{job.company}</span>
      </div>
      <div className="job-details">
        <span className="job-detail-item">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="icon" /> {job.location}
        </span>
        <span className="job-detail-item">
          <FontAwesomeIcon icon={faClock} className="icon" /> {job.experience} Years
        </span>
      </div>
      <div className="job-badges">
        <span className="job-badge">
          <FontAwesomeIcon icon={faBriefcase} className="icon" /> {job.jobType}
        </span>
        <span className="job-badge">
          <FontAwesomeIcon icon={faGlobe} className="icon" /> {job.workMode}
        </span>
      </div>
      <div className="job-meta">
        <span>Category: {job.jobCategory}</span>
        <span>Posted: {job.postedDate}</span>
      </div>
      <div className="job-actions">
        <button
          className="action-button action-button-primary"
          onClick={handleApply}
        >
          Details
        </button>
      </div>
    </div>
  );
}

export default JobCard;